import LandingTemplate from 'src/components/templates/Landing'
import { BlogBanner } from 'src/components/Blog/BlogBanner'
import { BlogPostContainer } from 'src/components/Blog/BlogPostContainer'

const post = () => {
  const menu = [{
    title: 'Blog',
    url: '/blog',
  }]

  // const urlImage = 'https://s3.sa-east-1.amazonaws.com/fzacademiaproduction/blog/covers/acordeoneros-de-diomedes-diaz.jpg'

  return (
    <LandingTemplate menu={menu}>
      <BlogBanner />
      <BlogPostContainer />
    </LandingTemplate>
  )
}

export default post
